import { map } from 'lodash';
import { articleStyle } from './articleStyle';
import { ExternalLink } from '@msrceng/component';

/**
 * Renders the list of items to a list of clickable links.
 *
 * > Behavior for missing URL's: the text is displayed, but
 * > it should not be hyperlinked (no anchor tag around it)
 */
export const UrlList = ({ list, nameKey, urlKey }: IUrlListProps) => {
  if (!list || list.length < 1) {
    return <>-</>;
  }
  return (
    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
      {map(list, (item, index) => {
        const articleName = item[nameKey];
        const articleUrl = item[urlKey];
        const hasUrl = articleUrl && articleUrl.length > 4; //http is 4 characters
        return (
          <li key={`li-${articleName}-${index}`} style={articleStyle.li}>
            {hasUrl && (
              <ExternalLink href={articleUrl}>
                {articleName || articleUrl || '-'}
              </ExternalLink>
            )}
            {!hasUrl && (articleName || '-')}
          </li>
        );
      })}
    </ul>
  );
};

export interface IUrlListProps {
  /** list of items with url's and titles */
  list: any[];
  /**  name/title of the item */
  nameKey: string;
  /**  url to link to */
  urlKey: string;
}
